import { Component, OnInit } from "@angular/core";
import { ISharePointGroupHolder } from "@coso-replicator/core";
import { FormText, SelectBoxOption, FormBuilder, FormGroup } from "@coso/forms";
import { Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone:false,
  templateUrl: "./add-group.component.html"
})
export class AddGroupComponent implements OnInit {
  formGroup: FormGroup<ISharePointGroupHolder>;
  formText: FormText<ISharePointGroupHolder>;
  sharePointGroups: ISharePointGroupHolder[];
  saveCallback: (entity: ISharePointGroupHolder) => void;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.formGroup = this.fb.group<any>({
      id: this.fb.control(null, [Validators.required])
    });
    const options: SelectBoxOption[] = this.sharePointGroups.map((s) => {
      return { label: s.name, value: s.id, disabled: false };
    });
    this.formText = {
      id: {
        label: "SharePoint Group",
        labelClass: "col-lg-4",
        inputContainerClass: "col-lg-6",
        options: [{ label: "---NONE---", value: null, disabled: true }, ...options],
        errors: {
          required: "This is required."
        }
      }
    };
  }

  save() {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
    } else {
      const formValue = this.formGroup.getRawValue();
      const index = this.sharePointGroups.findIndex((s) => s.id === formValue.id);
      const selectedGroup = this.sharePointGroups[index];
      this.saveCallback(selectedGroup);
    }
  }
}
